import { render, staticRenderFns } from "./BulkCreate.vue?vue&type=template&id=337db9d7&"
import script from "./BulkCreate.vue?vue&type=script&lang=js&"
export * from "./BulkCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports